import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)">

<path d="M4875 8584 c-308 -36 -568 -123 -777 -261 -109 -72 -226 -184 -309
-294 -56 -75 -135 -239 -164 -341 -77 -266 -49 -602 70 -838 72 -143 221 -307
370 -407 140 -94 374 -191 837 -347 332 -112 383 -131 504 -191 179 -87 255
-171 275 -300 28 -178 -70 -371 -226 -444 -122 -57 -223 -80 -395 -88 -155 -7
-291 6 -437 42 -313 76 -600 210 -853 399 -124 93 -118 90 -146 77 l-24 -11 0
-389 0 -390 68 -39 c452 -263 954 -389 1462 -368 402 16 697 103 999 294 76
48 226 201 286 292 198 302 241 745 104 1083 -58 144 -193 321 -318 418 -178
136 -341 207 -1096 474 -88 31 -224 87 -301 125 -120 58 -152 78 -207 133 -85
84 -110 145 -111 272 -1 113 21 176 86 249 54 60 143 112 258 148 68 21 94 23
265 23 145 0 209 -4 270 -18 295 -65 601 -195 846 -359 198 -132 189 -147 189
332 l0 379 -30 21 c-35 25 -225 116 -320 153 -184 72 -431 135 -635 162 -108
14 -448 19 -540 9z"/>
<path d="M6742 3939 c-55 -28 -94 -84 -99 -147 -12 -129 138 -229 265 -177 75
32 112 86 112 165 0 56 -15 93 -52 126 -63 58 -150 70 -226 33z"/>
<path d="M5392 3933 l-132 -4 2 -822 3 -822 145 0 145 0 3 37 c5 57 24 66 72
32 103 -74 182 -98 320 -97 228 0 386 84 474 252 57 108 76 200 76 360 0 158
-14 231 -65 330 -63 126 -180 219 -321 255 -84 22 -213 20 -297 -3 -65 -18
-177 -81 -177 -100 0 -16 -40 -23 -55 -11 -13 10 -15 60 -15 296 0 270 -1 284
-19 294 -11 5 -21 9 -23 8 -2 -1 -63 -4 -136 -5z m604 -758 c65 -32 130 -96
158 -155 16 -36 20 -65 21 -150 0 -95 -3 -110 -28 -162 -50 -102 -176 -188
-275 -188 -44 0 -125 21 -168 43 -51 26 -102 91 -120 153 -24 83 -16 261 15
324 75 154 242 211 397 135z"/>
<path d="M2637 3924 c-9 -9 -9 -1606 -1 -1628 5 -14 28 -16 148 -16 97 0 146
4 154 12 9 9 12 103 12 362 0 221 4 365 11 390 7 25 30 58 63 92 74 74 140 90
244 59 62 -19 105 -54 135 -109 21 -40 22 -53 27 -413 3 -246 9 -376 16 -383
7 -7 60 -10 150 -8 l139 3 3 408 c2 443 -2 487 -53 585 -31 58 -39 69 -93 111
-65 51 -133 73 -242 79 -153 7 -240 -19 -327 -99 -73 -67 -72 -68 -75 265 l-3
291 -151 3 c-82 1 -153 -1 -157 -4z"/>
<path d="M1895 3456 c-106 -22 -195 -78 -244 -154 -65 -103 -78 -236 -31 -334
47 -100 141 -163 310 -208 225 -59 270 -86 270 -159 0 -31 -7 -48 -30 -74 -67
-77 -227 -67 -439 25 l-73 33 -18 -23 c-31 -38 -74 -163 -63 -181 25 -40 207
-106 336 -122 201 -24 377 22 483 127 147 145 132 396 -28 497 -66 41 -141 69
-282 102 -125 29 -180 56 -197 96 -24 59 16 140 77 155 14 4 60 4 102 2 73 -5
128 -25 264 -96 16 -8 80 128 95 200 5 25 1 29 -63 58 -145 66 -317 87 -469
56z"/>
<path d="M3934 3436 c-3 -8 -4 -205 -1 -437 4 -444 6 -469 52 -559 9 -19 35
-52 58 -73 154 -146 441 -151 613 -11 29 24 63 44 74 44 17 0 20 -7 20 -48 0
-26 5 -53 12 -60 14 -14 245 -17 266 -4 10 7 12 130 10 583 l-3 574 -150 0
-150 0 -5 -370 c-5 -404 -7 -414 -68 -478 -53 -56 -107 -80 -180 -80 -107 0
-172 44 -219 149 -16 34 -19 82 -23 409 l-5 370 -148 3 c-120 2 -148 0 -153
-12z"/>
<path d="M6673 3444 c-17 -7 -19 -1114 -3 -1145 10 -17 23 -19 149 -19 105 0
141 3 150 14 8 9 10 170 9 582 l-3 569 -145 2 c-80 1 -151 -1 -157 -3z"/>
<path d="M7177 3443 c-4 -3 -7 -55 -7 -114 0 -88 3 -108 16 -113 9 -3 123 -6
255 -6 256 0 265 -2 240 -48 -12 -22 -270 -369 -404 -544 -45 -59 -90 -122
-99 -140 -23 -41 -25 -170 -4 -187 9 -8 143 -10 477 -9 l464 3 3 108 c1 59 1
108 0 109 -2 1 -122 5 -268 8 -239 4 -265 7 -268 22 -4 18 26 60 331 467 l198
265 -3 90 -3 91 -461 3 c-253 1 -464 -1 -467 -5z"/>
<path d="M6110 2016 c-72 -16 -113 -38 -164 -89 -77 -78 -106 -169 -87 -275
32 -179 166 -283 347 -269 72 5 194 49 194 69 0 15 -38 84 -53 97 -12 10 -23
9 -53 -4 -47 -20 -127 -22 -176 -6 -105 35 -142 191 -65 278 60 68 143 81 235
38 30 -14 55 -25 57 -25 5 0 65 112 65 122 0 12 -78 49 -135 64 -60 16 -92 16
-165 0z"/>
<path d="M6673 2015 c-67 -19 -121 -53 -166 -105 -60 -71 -72 -104 -72 -205 1
-115 25 -175 100 -244 70 -64 137 -85 248 -79 132 7 214 61 273 178 24 46 28
68 29 135 0 68 -5 90 -29 143 -67 145 -230 220 -383 177z m150 -149 c129 -53
143 -255 22 -320 -58 -32 -165 -17 -211 28 -54 55 -59 176 -10 241 47 61 127
82 199 51z"/>
<path d="M7455 2021 c-42 -10 -72 -28 -89 -52 -18 -26 -46 -19 -46 11 0 18 -6
20 -70 20 l-70 0 2 -302 3 -303 70 0 70 0 5 200 c4 175 7 204 25 232 42 70
117 75 166 10 23 -31 24 -40 29 -237 l5 -205 70 0 70 0 5 200 c4 176 7 205 24
230 28 43 46 54 87 55 27 0 43 -8 70 -36 l34 -35 3 -210 4 -209 68 0 c48 0 71
4 80 15 9 11 11 69 8 232 -5 245 -11 269 -78 334 -75 73 -186 74 -278 3 l-46
-35 -31 31 c-18 17 -54 38 -80 46 -52 15 -64 16 -110 5z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
